export default {"src":"/_next/static/media/stack-of-mail.86e7a676.svg","height":448,"width":500};